import React from 'react';
import { Box, Typography } from '@mui/material';
import LuxuraAI_AWB from './aiLibrary/luxura_AI_AWB';
import LuxuraAI_Taskjira from './aiLibrary/luxura_AI_taskjira';
import LuxuraAI_Intrari from './aiLibrary/luxura_AI_Intrari';

export default function LuxuraAIMain() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 700 }}>
        Luxura AI
      </Typography>
      <LuxuraAI_AWB />
      <Box sx={{ mt: 4 }}>
        <LuxuraAI_Intrari />
      </Box>
      <Box sx={{ mt: 4 }}>
        <LuxuraAI_Taskjira />
      </Box>
    </Box>
  );
}